<template>
  <div>
    <v-card class="clone" elevation="0" width="900">
      <v-container id="print">
        <v-card-title class="justify-center">
          지출결의서
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-end align-center mb-3">
            <p class="mb-0 mr-4">부서장</p>
            <v-btn depressed color="primary" @click="handleApproval">
              결재
            </v-btn>
          </div>
          <div class="d-flex justify-space-between mb-1">
            <div>
              <table class="tbl-title">
                <tbody>
                  <tr>
                    <th>귀속년월</th>
                    <td>{{ data.imptYm }}</td>
                  </tr>
                  <tr>
                    <th>작성일</th>
                    <td>{{ data.wrDt }}</td>
                  </tr>
                  <tr>
                    <th>부서</th>
                    <td>{{ data.deptNm }}</td>
                  </tr>
                  <tr>
                    <th>직급</th>
                    <td>{{ data.empRankNm }}</td>
                  </tr>
                  <tr>
                    <th>기안자</th>
                    <td>{{ data.empNm }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table class="tbl-stamp">
                <tbody>
                  <tr>
                    <th rowspan="3">결재</th>
                    <th>담당</th>
                    <th v-for="sign in data.signLIst" :key="sign.cashDsbrVchNo">
                      {{ sign.signEmpNm }}
                    </th>
                  </tr>
                  <tr>
                    <td>{{ data.empNm }}</td>
                    <td v-for="sign in data.signLIst" :key="sign.cashDsbrVchNo">
                      {{ sign.signEmpNm }}
                    </td>
                  </tr>
                  <tr class="tr-name">
                    <td>{{ data.wrDt }}</td>
                    <td v-for="sign in data.signLIst" :key="sign.cashDsbrVchNo">
                      {{ sign.signDt }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="mt-8 mb-3">담당자 결재의견 : {{ data.note }}</p>
          <p>
            첨부파일 :
            <button
              type="button"
              class="btn-files"
              v-for="file in data.fileList"
              :key="file.fileNo"
              @click="handleFileDown(file.fileNo, file.fileNm)"
            >
              {{ file.fileNm }}
            </button>
          </p>
          <div>
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              disable-pagination
              mobile-breakpoint="0"
              class="table-doc"
            >
              <template v-slot:[`body.append`]>
                <tr class="tfoot">
                  <td colspan="4">합계</td>
                  <td class="right">{{ total }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div>
            <p class="mt-10 black--text">
              위와 같이 지출을 결의하오니 허가하여 주시기 바랍니다.
            </p>
            <div class="text-right black--text">
              <p>{{ this.wrDtKr }}</p>
              <p>작성자 {{ data.empNm }} (인)</p>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center" data-html2canvas-ignore="true">
          <v-btn
            elevation="0"
            color="primary"
            :to="`/approval/write/${$route.params.id}`"
            >수정</v-btn
          >
          <v-btn elevation="0" outlined color="primary" to="/approval/list">
            목록
          </v-btn>
          <v-btn elevation="0" outlined color="red" @click="handleDelete">
            삭제
          </v-btn>
          <v-btn elevation="0" color="amber" @click="pdfDown">
            PDF 다운로드
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SetComma from "@/mixins/SetComma";
import { approvalDsbr, delDsbr, detailDsbr } from "@/api/approval";
import { downloadFile } from "@/api/common";

export default {
  data() {
    return {
      propTitle: "지출결의서",
      headers: [
        {
          text: "No",
          value: "seq",
          width: "5%",
          align: "center",
          sortable: false,
          divider: true,
        },
        {
          text: "계정과목",
          value: "subject",
          width: "15%",
          align: "center",
          sortable: false,
          divider: true,
        },
        {
          text: "거래처/사용자",
          value: "userNm",
          width: "15%",
          align: "center",
          sortable: false,
          divider: true,
        },
        {
          text: "적요",
          value: "summary",
          width: "50%",
          align: "left",
          sortable: false,
          divider: true,
        },
        {
          text: "금액",
          value: "amt",
          width: "20%",
          align: "right",
          sortable: false,
        },
      ],
      items: [],
      data: [],
      total: "",
      snackbar: { show: false, message: "" },
    };
  },
  computed: {
    wrDtKr() {
      return moment(this.data.wrDt).format("YYYY년 M월 DD일");
    },
  },
  mixins: [SetComma],
  created() {
    this.loadDetail();
  },
  methods: {
    async loadDetail() {
      try {
        const { data } = await detailDsbr(this.$route.params.id);
        let calTotal = 0;
        const newItemLIst = data.form.itemList.map(v => {
          calTotal += v.amt;
          v.amt = `￦${this.comma(v.amt)}`;

          return v;
        });

        this.data = data.form;
        this.items = newItemLIst;
        this.total = `￦${this.comma(calTotal)}`;
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    async handleApproval() {
      try {
        const id = this.$route.params.id;
        const formData = {
          cashDsbrVchNo: id,
          empNm: this.data.empNm,
          empNo: this.data.empNo,
          signAprYn: "Y",
          signDt: moment().format("YYYYMMDD"),
          signEmpCd: 108100,
          signEmpNm: 108100,
        };
        const { data } = await approvalDsbr(id, formData);

        if (data.res === 1) {
          this.snackbar.message = "결재되었습니다.";
          this.snackbar.show = true;
        }
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    async handleDelete() {
      try {
        const { data } = await delDsbr(this.$route.params.id);
        if (data.ret === 1) {
          this.snackbar.message = "삭제되었습니다.";
          this.snackbar.show = true;

          setTimeout(() => {
            this.$router.push("/approval/list");
          }, 500);
        } else {
          this.snackbar.message = "삭제 실패했습니다.";
          this.snackbar.show = true;
        }
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    async handleFileDown(fileNo, fileNm) {
      try {
        const res = await downloadFile(fileNo);
        console.log(res);

        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });

        const fileLink = document.createElement("a");
        fileLink.href = window.URL.createObjectURL(blob);
        fileLink.target = "_self";
        fileLink.download = fileNm;
        fileLink.click();
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    pdfDown() {
      this.makePDF("#print");
    },
    makePDF(selector = "body") {
      window.html2canvas = html2canvas; //Vue.js 특성상 window 객체에 직접 할당해야한다.
      let that = this;
      let pdf = new jsPDF("p", "mm", "a4");
      let canvas = pdf.canvas;
      const pageWidth = 210; //캔버스 너비 mm
      const pageHeight = 295; //캔버스 높이 mm
      canvas.width = pageWidth;

      let ele = document.querySelector(selector);
      let width = ele.offsetWidth; // 셀렉트한 요소의 px 너비
      let height = ele.offsetHeight; // 셀렉트한 요소의 px 높이
      let imgHeight = (pageWidth * height) / width; // 이미지 높이값 px to mm 변환

      if (!ele) {
        console.warn(selector + " is not exist.");
        return false;
      }

      html2canvas(ele, { scale: 3 }).then(function(canvas) {
        let position = 0;
        const imgData = canvas.toDataURL("image/png");

        pdf.addImage(
          imgData,
          "png",
          0,
          position,
          pageWidth,
          imgHeight,
          undefined,
          "slow",
        );

        //Paging 처리
        let heightLeft = imgHeight; //페이징 처리를 위해 남은 페이지 높이 세팅.
        heightLeft -= pageHeight;
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "png", 0, position, pageWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save(that.propTitle.toLowerCase() + ".pdf");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.right {
  text-align: right !important;
}
.table-doc {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0;

  thead th,
  .tfoot td {
    height: 38px !important;
    background: #eee;
  }
}

.tfoot td {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center;
}
.tfoot td + td {
  border-right: 0;
}

.tbl-stamp {
  border-collapse: collapse;

  th,
  td {
    width: 80px;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  th:first-child {
    width: 25px;
    background: #eee;
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }

  th {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  td {
    height: 70px;
    text-align: center;
  }
  .tr-name td {
    height: auto;
  }
}

.tbl-title {
  border-collapse: collapse;

  th,
  td {
    padding: 3px 5px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    text-align: left;
  }
  th {
    width: 80px;
    background: #eee;
  }
  td {
    width: 150px;
  }
}

.btn-files {
  margin-right: 8px;

  &:hover {
    text-decoration: underline;
  }
}
</style>
